import { Routes } from '@angular/router';
import { NotFound } from './views/error-pages/not-found/not-found';
import { Unauthorized } from './views/error-pages/unauthorized/unauthorized';
import { Auth } from './views/auth/auth';
import { Base } from './views/layout/base/base';
import { authenticationGuard } from './core/guards/authentication/authentication-guard';

import { SettingsBase } from './views/settings/settings-base/settings-base';
import { titleResolver } from './core/resolvers/title-resolver/title-resolver';

export const routes: Routes = [
  {
    path: '',
    component: Base,
    canActivate: [authenticationGuard],
    children: [
      {
        path: '',
        data: { title: 'sideMenu.home' },
        resolve: { pageTitle: titleResolver },
        loadComponent: () => import('./views/home/home').then((m) => m.Home),
      },
      {
        path: 'settings',
        data: { title: 'sideMenu.settings' },
        resolve: { pageTitle: titleResolver },
        component: SettingsBase,
        children: [
          {
            path: 'support',
            data: { title: 'sideMenu.support' },
            resolve: { pageTitle: titleResolver },
            loadComponent: () =>
              import('./views/settings/create-support/create-support').then(
                (m) => m.CreateSupport
              ),
          },
        ],
      },
      {
        path: 'commissions',
        data: { title: 'sideMenu.commissions' },
        resolve: { pageTitle: titleResolver },
        loadComponent: () =>
          import('./views/commissions/all-commissions/all-commissions').then(
            (m) => m.AllCommissions
          ),
      },
      {
        path: 'products',
        children: [
          {
            path: '',
            data: { title: 'sideMenu.products' },
            resolve: { pageTitle: titleResolver },
            loadComponent: () =>
              import('./views/products/all-products/all-products').then(
                (m) => m.AllProducts
              ),
          },
          {
            path: 'create-product',
            data: { title: 'sideMenu.createProduct' },
            resolve: { pageTitle: titleResolver },
            loadComponent: () =>
              import('./views/products/create-product/create-product').then(
                (m) => m.CreateProduct
              ),
          },
          {
            path: ':productID/update-product',
            data: { title: 'sideMenu.updateProduct' },
            resolve: { pageTitle: titleResolver },
            loadComponent: () =>
              import('./views/products/update-product/update-product').then(
                (m) => m.UpdateProduct
              ),
          },
        ],
      },

      {
        path: 'orders',

        children: [
          {
            path: '',
            data: { title: 'sideMenu.orders' },
            resolve: { pageTitle: titleResolver },
            loadComponent: () =>
              import('./views/orders/all-orders/all-orders').then(
                (m) => m.AllOrders
              ),
          },
          {
            path: ':orderID',
            data: { title: 'orders.orderDetails' },
            resolve: { pageTitle: titleResolver },
            loadComponent: () =>
              import('./views/orders/order-details/order-details').then(
                (m) => m.OrderDetails
              ),
          },
        ],
      },

      {
        path: 'working-hours',

        data: { title: 'sideMenu.workingHours' },
        resolve: { pageTitle: titleResolver },
        loadComponent: () =>
          import('./views/working-hours/working-hours').then(
            (m) => m.WorkingHours
          ),
      },
      {
        path: 'finance-management',
        data: { title: 'sideMenu.financeManagement' },
        resolve: { pageTitle: titleResolver },
        children: [
          {
            path: '',
            data: { title: 'sideMenu.financeManagement' },
            resolve: { pageTitle: titleResolver },
            loadComponent: () =>
              import(
                './views/finance-management/all-finance-management/all-finance-management'
              ).then((m) => m.AllFinanceManagement),
          },
          {
            path: ':finance-managementID',
            data: { title: 'sideMenu.financeManagementDetails' },
            resolve: { pageTitle: titleResolver },
            loadComponent: () =>
              import(
                './views/finance-management/all-transactions/all-transactions'
              ).then((m) => m.AllTransactions),
          },
        ],
      },
    ],
  },
  {
    path: 'auth',
    component: Auth,
    children: [
      {
        path: 'login',
        data: { title: 'sideMenu.login' },
        resolve: { pageTitle: titleResolver },
        loadComponent: () =>
          import('./views/auth/login/login').then((m) => m.Login),
      },
      {
        path: 'forgot-password',
        data: { title: 'sideMenu.forgotPassword' },
        resolve: { pageTitle: titleResolver },
        loadComponent: () =>
          import('./views/auth/forgot-password/forgot-password').then(
            (m) => m.ForgotPassword
          ),
      },
      {
        path: 'reset-password',
        data: { title: 'sideMenu.resetPassword' },
        resolve: { pageTitle: titleResolver },
        loadComponent: () =>
          import('./views/auth/reset-password/reset-password').then(
            (m) => m.ResetPassword
          ),
      },
    ],
  },
  {
    path: 'errors',
    children: [{ path: 'unauthorized', component: Unauthorized }],
  },
  { path: '**', component: NotFound },
];
